import script from "./YouTubePlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./YouTubePlayer.vue?vue&type=script&setup=true&lang=js"

import "./YouTubePlayer.vue?vue&type=style&index=0&id=38d71074&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38d71074"]])

export default __exports__